// extracted by mini-css-extract-plugin
export default {"root":"fDrfy6Hp","mobilePresets":"zjrql_yp"};